<template>
    <div class="integrations">
        <VHeader page="Integrations"></VHeader>
        <div
            class="integrations-cards"
        >
            <template v-if="!this.$route.params.type">
                <div class="items">
                    <template>
                        <card
                            v-for="(integration, integrationIndex) in integrationCards"
                            :key="integrationIndex"
                            :integration="integration"
                            :are-integrations-updating="areIntegrationsUpdating"
                            @openIntegrationPage="openIntegrationPage"
                        />
                    </template>
                </div>
            </template>
            <div
                class="integration-page"
                v-else
            >
                <div
                    class="return-button"
                    @click="returnToIntegrationsCards"
                    v-if="currentCard"
                >
                    <div
                        class="icon"
                        :style="{'background-image':`url(${currentCard.icon})`}"
                    ></div>
                    <div class="name">{{ currentCard.title }}</div>
                </div>
                <div class="table highlighted-table">
                    <div class="table-header">
                        <div class="table-header-title">
                            Integrated by
                        </div>
                        <div class="table-header-title table-header-title_account-id">
                            Ad Account ID
                        </div>
                        <div class="table-header-title">
                            Status
                        </div>
                    </div>
                    <div
                        class="table-string "
                        v-for="currentIntegration in currentAdIntegrations"
                        :key="currentIntegration.id"
                    >
                        <div class="table-string-intelligence">
                            {{ currentIntegration.profile_name }}
                        </div>
                        <div class="table-string-intelligence table-string-intelligence_account-id">
                            {{ currentIntegration.adnetwork_id }}
                        </div>
                        <div
                            class="table-string-intelligence table-string-intelligence_green"
                            v-if="currentIntegration.active"
                        >
                            Active
                        </div>
                        <div
                            class="table-string-intelligence "
                            v-else
                        >
                            Inactive
                        </div>
                        <div
                            class=" table-string-close-icon"
                            @click="deleteIntergation(currentIntegration.adnetwork_id,currentIntegration.active)"
                        ></div>
                    </div>
                </div>
                <component
                    ref="currentCard"
                    :is="componentFile"
                    :integration-cards="integrationCards"
                    :current-location="currentLocation"
                    @initIntegration="initIntegration"
                    @addIntegration="addIntegrationApi"
                >
                </component>
            
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getIntegrationCards,
        setIntegrationCards,
        setCurrentAdIntegrations,
        getCurrentAdIntegrations,
    } from
            '../api/apiServices';
    import apiIntegrations from '../api/apiIntegrations';
    import Card from './Integrations/Card';
    import {sendIntegrationRequest, INTEGRATION_AUTH_STORAGE_KEY} from './Integrations/integrationHelper';
    import integrationCardsWithoutStatuses from '../api/apiServices/integrationCards.json';
    import {getUrlParam} from '@/helpers/urlHelper';
    
    export default {
        name: 'Integrations',
        components: {Card},
        data() {
            return {
                currentAdIntegrations: [],
                integrationCards: integrationCardsWithoutStatuses,
                areIntegrationsUpdating: true,
                currentLocation: '',
            };
        },
        computed: {
            componentFile() {
                return () => import(`./Integrations/Apps/${this.$route.params.type}.vue`);
            },
            currentCard() {
                return this.integrationCards.find((card) => card.type === this.$route.params.type);
            },
        },
        created() {
            this.currentLocation = `${window.location.origin}/integrations`;
            const urlState = getUrlParam('state');
            if (urlState) {
                const authData = {
                    state: urlState,
                    code: getUrlParam('code'),
                    auth_code: getUrlParam('auth_code') || '',
                };
                if (window.opener) {
                    window.opener.postMessage(authData, '*');
                }
                // the same-origin opener receives a 'storage' event even when window.opener is lost
                localStorage.setItem(INTEGRATION_AUTH_STORAGE_KEY, JSON.stringify(authData));
                window.close();
            } else {
                if (getIntegrationCards().length) {
                    this.integrationCards = getIntegrationCards();
                    this.areIntegrationsUpdating = false;
                } else {
                    this.getAllIntegrations();
                }
                if (getCurrentAdIntegrations().length) {
                    this.currentAdIntegrations = Object.freeze(getCurrentAdIntegrations());
                } else if (this.$route.params.type) {
                    this.getCurrentAdIntegrations(this.$route.params.type);
                }
            }
        },
        methods: {
            async openIntegrationPage(integrationName) {
                await this.getCurrentAdIntegrations(integrationName);
                this.$router.push(`/integrations/${integrationName}`);
            },
            getCurrentAdIntegrations(integrationName) {
                return apiIntegrations.currentAdIntegrations(integrationName).then((res) => {
                    this.currentAdIntegrations = Object.freeze(res.data);
                    setCurrentAdIntegrations(res.data);
                    this.integrationCards = getIntegrationCards();
                    
                }).catch(() => {
                    this.$toastr.longError(
                        'api error',
                    );
                });
            },
            returnToIntegrationsCards() {
                this.$router.push('/integrations');
            },
            getAllIntegrations() {
                apiIntegrations.getAdNetworks().then((response) => {
                    window.savedRequests.integrations = response.data;
                    setIntegrationCards(response.data);
                    this.integrationCards = getIntegrationCards();
                    this.areIntegrationsUpdating = false;
                });
            },
            addIntegrationApi(code, integrationType) {
                apiIntegrations.addAdIntegration(code, integrationType).then(() => {
                    this.getAllIntegrations();
                    this.$toastr.s(
                        'Integration was successful',
                    );
                    this.$router.push(`/integrations`);
                  
                }).catch((error) => {
                    this.$toastr.longError(
                        `Integration failed. ${error.response.data.error}`,
                    );
                });
            },
            initIntegration(integrationType) {
                const integration = this.integrationCards.find((card) => card.type === integrationType);
                if (!integration.run) {
                    sendIntegrationRequest(integration.type, integration.data).then((response) => {
                        this.addIntegrationApi(response, integrationType);
                    }).catch((reject) => {
                        this.$toastr.longError(
                            reject.errorMessage,
                        );
                    });
                } else {
                    this.$router.push(`/integrations`);
                }
            },
            deleteIntergation(id, isActive) {
                const integrationType = this.$route.params.type;
                const integration = this.integrationCards.find((card) => card.type === integrationType);
                apiIntegrations.deleteAdNetworkById(integrationType, id).then(() => {
                    this.currentAdIntegrations = Object.freeze(_.clone(this.currentAdIntegrations).filter((integration) => integration.adnetwork_id !== id));
                    if (isActive) {
                        integration.active--;
                    } else {
                        integration.inactive--;
                    }
                }).catch(() => {
                    this.$toastr.longError(
                        `Failed`,
                    );
                });
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .integration {
        &-page {
            display: flex;
            flex-direction: column;
        }
    }
    
    .integrations {
        margin: 0 auto;
        
        &-cards {
            padding: 26px;
            
        }
        
        ::v-deep {
            .integrations-cards {
                min-width: 840px;
                
            }
        }
        
        
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        
        
        &__templates {
            font-size: 16px;
            line-height: 20px;
            font-weight: 700;
            margin-bottom: 16px;
            padding-left: 3px;
            text-align: left;
        }
        
        .items {
            display: flex;
            flex-wrap: wrap;
            margin-left: -10px;
            margin-right: -10px;
        }
        
        ::v-deep {
            .return-button {
                display: flex;
                width: 180px;
            }
            
            .icon {
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                width: 20px;
                height: 20px;
                margin-top: -5px;
                margin-left: 30px;
            }
            
            .name {
                //width: 100px;
                margin-top: -4px;
                margin-left: 9px;
                margin-bottom: 5px;
                font: Quicksand;
                font-weight: 600;
                letter-spacing: 0;
                Size: 16px;
                Line-height: 20px;
                color: #000F48;
            }
        }
        
        .table {
            border-radius: 10px;
            @include dark-shadow;
            margin-bottom: 30px;
            
            
            &-header {
                display: flex;
                height: 45px;
                border-bottom: 1px solid #6089E7;
                padding-left: 23px;
                @media (max-width: 1000px) {
                    padding-left: 5px;
                    padding-right: 20%;
                }
                
                &-title {
                    display: flex;
                    margin-top: 23px;
                    font-family: Poppins;
                    height: 12px;
                    color: #000F48;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 12px;
                    width: 200px;
                    
                    &_account-id {
                        width: 350px;
                    }
                }
            }
            
            &-string {
                
                display: flex;
                align-items: center;
                height: 45px;
                padding-left: 23px;
                padding-right: 46px;
                border-top: 1px solid rgba(96, 137, 231, 0.2);
                @media (max-width: 1000px) {
                    padding-left: 5px;
                    padding-right: 2%;
                }
                
                &-intelligence {
                    font-family: Quicksand;
                    height: 18px;
                    color: #000F48;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 18px;
                    width: 200px;
                    text-align: left;
                    @media (max-width: 1000px) {
                        font-size: 12px;
                    }
                    
                    &_account-id {
                        width: 350px;
                        
                    }
                }
                
                
                &-intelligence_green {
                    color: #00CD96;
                    font-weight: bold;
                }
                
                &-close-icon {
                    display: flex;
                    float: right;
                    
                    width: 17px;
                    height: 17px;
                    background-position: 0 0;
                    background-repeat: no-repeat;
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                    cursor: pointer;
                }
            }
        }
        
        ::v-deep {
            .facebook-button {
                background: #3B5998;
            }
        }
        
        .integration {
            //margin-top: -35px;
            display: flex;
            justify-content: flex-end;
            padding-right: 15px;
            
            &__plus {
                margin-top: -2px;
                margin-right: 2px;
                font-size: 34px;
                color: #6089E7;
            }
            
            &__btn {
                margin-top: 7px;
                display: block;
                font-family: Quicksand;
                height: 18px;
                color: #6089E7;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 18px;
                cursor: pointer;
                @media (max-width: 1000px) {
                    font-size: 12px;
                }
                
            }
        }
    }
</style>
